import SkillsSection from "#app/components/skillsSection.tsx";
import WatchCTA from "#app/routes/resources+/watch-cta.tsx";

export default function SkillsRoute() {
	return (
    <main className="container mx-auto text-black dark:text-white">
        <SkillsSection />
        <div className="p-4 sm:p-6 md:p-8 lg:p-10">
            <WatchCTA />
        </div>
    </main>
    )
}